var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.windowWidth < 780.89)?_c('div',{staticClass:"navigate-steps-mob__holder"},[_c('div',{staticClass:"navigate-steps-mob",style:({
      width: ((_vm.circleSize * 1.2) + "px"),
      height: ((_vm.circleSize * 1.2) + "px"),
    })},[_c('div',{staticClass:"navigate-steps-mob__elements"},_vm._l((_vm.steps),function(step,index){return _c('div',{key:index,staticClass:"navigate-steps-mob__item",class:[
          {
            'navigate-steps-mob__item--active': _vm.activeStepId === index,
            'navigate-steps-mob__item--after': index - _vm.activeStepId < 0,
            'navigate-steps-mob__item--before': index - _vm.activeStepId > 0,
          } ],style:(_vm.calcTransformShift(index))},[_c('span',[_vm._v(_vm._s(_vm.$t((step + ".step"))))])])}),0)])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }